export default {
  permissions_radomize: {
    name: 'Permissions Randomization Platform',
    fields: [
      {
        key: 'site_access',
        name: 'Site access',
      },
      {
        key: 'randomization_access',
        name: 'Randomization access',
      },
      {
        key: 'consent_access',
        name: 'Consent access',
      },
      {
        key: 'validate_randomization_access',
        name: 'Validation access',
      },
      {
        key: 'sae_access',
        name: 'SAE access',
      },
    ],
  },
  permissions_admin_dashboard: {
    name: 'Dashboard',
    fields: [
      {
        key: 'dashboard',
        name: 'Dashboard',
        permissions: [{ key: 'read', value: 'Read'}, { key: 'read_enrolment_by_site', value: 'Enrolment by Site Graph'}, { key: 'read_enrolment_stages', value: 'Enrolment by Stage Graph'}, { key: 'read_sae', value: 'SAE Graph'}, { key: 'read_deviation', value: 'Deviations Graph'}, { key: '90d_follow_ups', value: '90-Day Follow-ups'}]
      },
    ]
  },
  permissions_admin_patient: {
    name: 'Patients',
    fields: [
      {
        key: 'patient_profile',
        name: 'Patient Profile',
        permissions: [{ key: 'create', value: 'Create'}, { key: 'read', value: 'Read'}, { key: 'read_restricted', value: 'Read restricted'}, { key: 'update', value: 'Update'}, { key: 'delete', value: 'Delete'}, { key: 'unlock', value: 'Unlock'}, { key: 'lock', value: 'Lock'}]
      },
      {
        key: 'patient_document',
        name: 'Patient Documents',
        permissions: [{ key: 'create', value: 'Create'}, { key: 'read', value: 'Read'}, { key: 'update', value: 'Update'}, { key: 'delete', value: 'Delete'}]
      },
      {
        key: 'follow_up_90d',
        name: '90-Day Follow-ups',
        permissions: [{ key: 'create', value: 'Create'}, { key: 'read', value: 'Read'}, { key: 'update', value: 'Update'}, { key: 'delete', value: 'Delete'}, { key: 'unlock', value: 'Unlock'}, { key: 'lock', value: 'Lock'}]
      },
      {
        key: 'sae',
        name: 'SAE',
        permissions: [{ key: 'create', value: 'Create'}, { key: 'read', value: 'Read'}, { key: 'update', value: 'Update'}, { key: 'delete', value: 'Delete'}, { key: 'unlock', value: 'Unlock'}, { key: 'lock', value: 'Lock'}]
      },
      {
        key: 'central_sae_comments',
        name: 'Central SAE Comments',
        permissions: [{ key: 'read', value: 'Central SAE Comments Read'}, { key: 'update', value: 'Central SAE Comments Update'}]
      },
      {
        key: 'sae_term_codes',
        name: 'SAE term codes',
        permissions: [{ key: 'view', value: 'SAE Term Codes View'}, { key: 'update', value: 'SAE Term Codes Update'}]
      },
      {
        key: 'enrolled_patient_summary_read',
        name: 'Enrolled Patients View'
      },
      {
        key: 'consent_given_update',
        name: 'Consent given update'
      },
    ]
  },
  manage_trial: {
    name: 'Admin Settings',
    fields: [
      {
        key: 'admin_settings',
        name: 'View Admin Settings Menu',
      },
      {
        key: 'role',
        name: 'Role',
        permissions: [{ key: 'create', value: 'Create'}, { key: 'read', value: 'Read'}, { key: 'update', value: 'Update'}, { key: 'delete', value: 'Delete'} ]
      },
      {
        key: 'user',
        name: 'User',
        permissions: [{ key: 'create', value: 'Create'}, { key: 'read', value: 'Read'}, { key: 'update', value: 'Update'}, { key: 'delete', value: 'Delete'} ]
      },
      {
        key: 'training',
        name: 'Training',
        permissions: [ { key: 'upsert', value: 'Upsert'} ]
      },
      {
        key: 'site',
        name: 'Site',
        permissions: [{ key: 'create', value: 'Create'}, { key: 'read', value: 'Read'}, { key: 'update', value: 'Update'}, { key: 'delete', value: 'Delete'} ]
      },
      {
        key: 'user_site_access',
        name: 'User Site Access',
        permissions: [{ key: 'create', value: 'Create'}, { key: 'read', value: 'Read'}, { key: 'update', value: 'Update'}, { key: 'delete', value: 'Delete'} ]
      },
      {
        key: 'consent_setting',
        name: 'Consent Settings',
        permissions: [{ key: 'create', value: 'Create'}, { key: 'read', value: 'Read'}, { key: 'update', value: 'Update'}, { key: 'delete', value: 'Delete'} ]
      },
      {
        key: 'general_setting',
        name: 'General Settings',
        permissions: [{ key: 'create', value: 'Create'}, { key: 'read', value: 'Read'}, { key: 'update', value: 'Update'}, { key: 'delete', value: 'Delete'} ]
      },
    ]
  },
  document_management: {
    name: 'Document Management',
    fields: [
      {
        key: 'document',
        name: 'Document Management',
        permissions: [{ key: 'create', value: 'Create'}, { key: 'read', value: 'Read'}, { key: 'update', value: 'Update'}, { key: 'delete', value: 'Delete'}, { key: 'approve', value: 'Approve'}, { key: 'unapprove', value: 'Unapprove'} ]
      },
    ]
  },
  document_access: {
    name: 'Document Access',
    fields: [
      {
        key: 'document_public_access',
        name: 'Public document access',
      },
      {
        key: 'document_general_access',
        name: 'General document access',
      },
      {
        key: 'document_general_private_access',
        name: 'General Private document access',
      },
      {
        key: 'document_per_site_access',
        name: 'Site document access',
      },
      {
        key: 'document_training_access',
        name: 'Training document access',
      },
      {
        key: 'document_validation_access',
        name: 'Validation document access',
      },
    ]
  },
  multi_factor_authentication: {
    name: 'Multi-factor Authentication',
    fields: [
      {
        key: 'two_factor',
        name: 'Multi-factor Authentication',
        permissions: [{ key: 'create', value: 'Create'}, { key: 'read', value: 'Read'}, { key: 'update', value: 'Update'}, { key: 'delete', value: 'Delete'} ]
      },
    ]
  },
  audit_log: {
    name: 'Audit Logs',
    fields: [
      {
        key: 'audit_log',
        name: 'Audit Logs',
        permissions: [{ key: 'read', value: 'Read'}, { key: 'edit', value: 'Edit'}, { key: 'delete', value: 'Delete'}, { key: 'review', value: 'Review'}, ]
      },
    ]
  },
  simulation: {
    name: 'Simulation',
    fields: [
      {
        key: 'simulation',
        name: 'Simulation',
        permissions: [{ key: 'read', value: 'Read'}, { key: 'create', value: 'Create'}, { key: 'delete', value: 'Delete'}, { key: 'update', value: 'Update'}, ]
      },
    ]
  },
  user_training: {
    name: 'Training Module',
    fields: [
      {
        key: 'user_training',
        name: 'User Training',
        permissions: [{ key: 'read', value: 'Read'}, { key: 'start', value: 'Start'}, { key: 'verify', value: 'Verify'}, { key: 'reset', value: 'Reset Retries'}, ]
      },
      {
        key: 'training_upsert',
        name: 'Create Training for users (admin only)'
      }
    ]
  },
  reports: {
    name: 'Reports',
    fields: [
      {
        key: 'reports_read',
        name: 'Reports read',
      },
      {
        key: 'reports_sites_read',
        name: 'Reports sites read'
      },
      {
        key: 'reports_users_read',
        name: 'Reports users read'
      },
      {
        key: 'reports_subjects_read',
        name: 'Reports subjects read'
      },
      {
        key: 'reports_sae_read',
        name: 'Reports sae read'
      },
      {
        key: 'reports_deviations_read',
        name: 'Reports deviations read'
      },
      {
        key: 'reports_consent_read',
        name: 'Reports consent read'
      },
      {
        key: 'reports_death_read',
        name: 'Reports death read'
      },
      {
        key: 'reports_blinded_allocations_read',
        name: 'Reports blinded allocations read'
      },
      {
        key: 'reports_combined_read',
        name: 'Reports combined read'
      },
      {
        key: 'reports_follow_up_read',
        name: 'Reports follow up read'
      }
    ]
  },
  notifications: {
    name: 'Randomization Platform Notifications',
    fields: [
      {
        key: 'notification',
        name: 'Randomization',
        permissions: [{ key: 'randomization_summary', value: 'Summary'}, { key: 'randomization_detailed', value: 'Detailed'}, { key: '2_day_reminder', value: '2-Day Reminder'}, { key: '7_day_reminder', value: '7-Day Reminder'},  ]
      },
      {
        key: 'notification_consent',
        name: 'Consent Obtained',
      },
      {
        key: 'notification_validate_randomization',
        name: 'Validate Randomization Complete',
      },
      {
        key: 'notification_validation_differs_from_randomization',
        name: 'Validation Differs from randomization',
      },
      {
        key: 'notification_randomization_closed',
        name: 'Notification Randomization Closed',
      },
      {
        key: 'notification_validation_sae_occurred',
        name: 'SAE occured',
      },
      {
        key: 'report_subject_summary',
        name: 'Report Subject Summary',
      },
    ]
  },
  notificationsAdmin: {
    name: 'Trial Management Portal Notifications',
    fields: [
      {
        key: 'notification_death',
        name: 'Death Occured',
      },
      {
        key: 'notification_new_user',
        name: 'New User',
      },
      {
        key: 'notification_new_user_welcome',
        name: 'New User Welcome Email',
      },
      {
        key: 'notification_new_site',
        name: 'New Site',
      },
      {
        key: 'notification_suspended_site',
        name: 'Site Suspended',
      },
      {
        key: 'notification_training_completed',
        name: 'Training Completed',
      },
      {
        key: 'notification_site_randomization_status_changed',
        name: 'Site Randomization - Activate / Deactivate',
      },
      {
        key: 'notification_document_expire',
        name: 'Notification document expire',
      },
      {
        key: 'notification_newsletter',
        name: 'Notification Newsletter',
      },
      {
        key: 'notification_consent_missing_report',
        name: 'Notification consent missing report',
      },
      {
        key: 'notification_user_status_changed',
        name: 'Notification user status changed',
      },
      {
        key: 'notification_90_day',
        name: '90-Day Follow-ups',
        permissions: [{ key: 'follow_up_completed', value: 'Completed'}, ]
      },
      {
        key: 'notification_document',
        name: 'Documents',
        permissions: [{ key: 'pending_approval', value: 'Pending Approval'}, { key: 'document_approved', value: 'Document Approved'}, ]
      },
    ]
  },

  newsletter: {
    name: 'Newsletter',
    fields: [
      {
        key: 'newsletter',
        name: 'Newsletter',
        permissions: [{ key: 'create', value: 'Create'}, { key: 'read', value: 'Read'}, { key: 'update', value: 'Update'}, { key: 'delete', value: 'Delete'}]
      },
    ]
  },
};



// WEBPACK FOOTER //
// ./src/components/SettingsRoleForm/fieldsMap.js